import { createContext, useContext } from 'react';

import { emptyFn } from '@app/constants';
import type { NNotificationProvider } from '@app/providers/NotificationProvider/NotificationProvider.types';

// Заглушка на случай использования вне NotificationProvider (в норме
// он смонтирован в корне приложения, так что реальные методы antd
// notification здесь никогда не вызываются).
export const NotificationContext = createContext<NNotificationProvider.Context>(
  {
    api: {} as NNotificationProvider.Context['api'],
    contextHolder: {},
    showNotification: emptyFn,
  }
);

export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    );
  }

  return context;
};
